/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DockDailyOccupancyStateList } from '../../models/dock-daily-occupancy-state-list';

export interface GetOccupancyState$Params {

/**
 * A date in ISO 8601 format : YYYY-MM-DD
 */
  date: string;
}

export function getOccupancyState(http: HttpClient, rootUrl: string, params: GetOccupancyState$Params, context?: HttpContext): Observable<StrictHttpResponse<DockDailyOccupancyStateList>> {
  const rb = new RequestBuilder(rootUrl, getOccupancyState.PATH, 'get');
  if (params) {
    rb.query('date', params.date, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DockDailyOccupancyStateList>;
    })
  );
}

getOccupancyState.PATH = '/custom/dock-occupancy';
